import DeltaWifiFeaturedVenues from './DeltaWifiFeaturedVenues';

export default DeltaWifiFeaturedVenues;
